import React, { Component } from "react";
import { Form, Col, Container } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import { getAuthorizedBranchIds } from "../../utils/authHelper";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import AdmissionBreadcrumb from "./AdmissionBreadcrumb";
import "./_admissionForms.scss";

// ── GQL Mutations ────────────────────────────────────────────
const ADD_ENQUIRY_FORM_DETAILS = gql`
  mutation ($params: ManageEnquiryFieldsInput!) {
    manageEnquiryFormFields(params: $params)
  }
`;

// removed CREATE_CUSTOM_FORM_FIELD mutation as it is no longer used

const GET_ENQUIRY_FORMS = gql`
  query ($institute_id: Int!, $branch_id: String!) {
    getEnquiryForms(institute_id: $institute_id, branch_id: $branch_id) {
      id
      form_name
    }
    getFormFieldTypes {
      id
      form_field_type
    }
  }
`;

// ── Helpers ──────────────────────────────────────────────────
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

// ── Helper: Title case field names ──────────────────────────
const toTitleCase = (str) => {
  return str
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const FIELD_SECTIONS = {
  PERSONAL: "Personal Details",
  FAMILY: "Family Details",
  COMMUNICATION: "Address & Communication",
};

const FIELD_MAPPING = {
  "student name": FIELD_SECTIONS.PERSONAL,
  gender: FIELD_SECTIONS.PERSONAL,
  "date of birth": FIELD_SECTIONS.PERSONAL,
  dob: FIELD_SECTIONS.PERSONAL,
  "student mobile": FIELD_SECTIONS.PERSONAL,
  "student email": FIELD_SECTIONS.PERSONAL,
  email: FIELD_SECTIONS.PERSONAL,
  aadhaar: FIELD_SECTIONS.PERSONAL,
  "aadhaar number": FIELD_SECTIONS.PERSONAL,
  "blood group": FIELD_SECTIONS.PERSONAL,
  mobile: FIELD_SECTIONS.PERSONAL,
  name: FIELD_SECTIONS.PERSONAL,
  "father name": FIELD_SECTIONS.FAMILY,
  "mother name": FIELD_SECTIONS.FAMILY,
  "guardian name": FIELD_SECTIONS.FAMILY,
  "father mobile": FIELD_SECTIONS.FAMILY,
  "father occupation": FIELD_SECTIONS.FAMILY,
  father_name: FIELD_SECTIONS.FAMILY,
  mother_name: FIELD_SECTIONS.FAMILY,
  "permanent address": FIELD_SECTIONS.COMMUNICATION,
  city: FIELD_SECTIONS.COMMUNICATION,
  state: FIELD_SECTIONS.COMMUNICATION,
  pincode: FIELD_SECTIONS.COMMUNICATION,
  address: FIELD_SECTIONS.COMMUNICATION,

};

// ── Component ────────────────────────────────────────────────
class CreateAdmissionFormPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch_id: "",
      branchError: "",
      form_name: "",
      formNameError: "",
      formSelectedValue: [],
      defaultSelectedValue: [],
      // Order of the two preview sections; first item renders on top.
      sectionOrder: ["basic", "additional"],
      selectedFieldTypes: {},
      selectedFieldOptions: {},
      selectedFieldLengths: {},
      selectedFieldRequired: {},
      optionInputValues: {},
      selectableFields: [],
      loadingSpinner: false,
      submitError: "",
      submitSuccess: false,
      dataClear: 0,
      existing_form_field_id: 0,
      isEditMode: false,
      isDisabled: false,
      // ── Custom field state ───────────────
      customFieldSearch: "", // for filtering the field list
      customCreateName: "", // for the independent create panel
      customCreateType: 1, // Will be updated by getTypeIdByName later
      customCreateError: "",
      customFieldSearchError: "",
      isCreatingField: false,
      // ── Create field modal ────────────────
      isCreateFieldModalOpen: false,
      createFieldInput: "",
      createFieldError: "",
    };
  }

  getDynamicFieldTypes = () => {
    const { getEnquiryForms } = this.props;
    if (getEnquiryForms && getEnquiryForms.getFormFieldTypes && getEnquiryForms.getFormFieldTypes.length > 0) {
      return getEnquiryForms.getFormFieldTypes.map(t => ({
        id: parseInt(t.id),
        label: toTitleCase(t.form_field_type.replace(/button/gi, ''))
      }));
    }
    // Fallback if loading
    return [
      { id: 1, label: "Text" },
      { id: 2, label: "Textarea" },
      { id: 3, label: "Number" },
      { id: 4, label: "Dropdown" },
      { id: 5, label: "Radio" },
      { id: 6, label: "Date" },
      { id: 7, label: "Checkbox" }
    ];
  };

  getTypeIdByName = (name) => {
     const types = this.getDynamicFieldTypes();
     const found = types.find(t => t.label.toLowerCase().includes(name.toLowerCase()));
     return found ? found.id : 1;
  };

  componentDidMount() {
    this.initModalState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.stateData !== prevProps.stateData ||
      (this.props.globals?.globalBranches !== prevProps.globals?.globalBranches && (!this.state.branch_id || this.state.branch_id === "null"))) {
      this.initModalState();
    }
  }

  isBasicLabel = (lbl) => {
    const l = lbl.toLowerCase().trim().replace(/_/g, " ");
    return (
      l === "name" ||
      l === "student name" ||
      l === "mobile" ||
      l === "mobile number" ||
      l === "student mobile" ||
      l === "primary contact number" ||
      l === "contact number" ||
      l === "phone number" ||
      l.includes("email") ||
      l.includes("gender") ||
      l.includes("sex") ||
      l === "date of birth" ||
      l === "dob" ||
      l === "enquiry class" ||
      l === "course name" ||
      l === "course" ||
      l === "stream"
    );
  };

  isAcademicDetail = (lbl) => {
    const l = lbl.toLowerCase().trim().replace(/_/g, " ");
    const academicKeywords = [
      "school", "cgpa", "percentage", "marks", "ssc gpa",
      "state", "district", "city", "pincode", "zipcode", "zip code"
    ];
    return academicKeywords.some(kw => l.includes(kw));
  };



  initModalState = async () => {
    const { getEnquiryFormFields, stateData } = this.props;
    const defaultFields = [];
    const selectableFields = [];
    const defaultFieldTypes = {};

    const processField = (obj) => {
      const label = obj.label.toLowerCase().trim();
      let typeId = this.getTypeIdByName('text');

      // Only auto-assign if not already set in state
      if (this.state.selectedFieldTypes && this.state.selectedFieldTypes[obj.id]) {
        typeId = this.state.selectedFieldTypes[obj.id];
      } else {
        // More conservative name-based matching
        if (label === "date of birth" || label === "dob" || label === "date")
          typeId = this.getTypeIdByName('date');
        else if (
          label === "address" ||
          label.includes("comment") ||
          label.includes("background") ||
          label.includes("remarks")
        )
          typeId = this.getTypeIdByName('textarea');
        else if (
          label === "primary contact number" ||
          label === "mobile" ||
          label === "mobile number" ||
          label === "student mobile" ||
          label.includes("number") ||
          label.includes("amount") ||
          label.includes("pincode") ||
          label.includes("id")
        )
          typeId = this.getTypeIdByName('number');
        else if (
          label === "gender" ||
          label === "sex" ||
          label === "enquiry class" ||
          label === "course" ||
          label === "stream"
        )
          typeId = this.getTypeIdByName('dropdown');
        else if (
          label.includes("branch") ||
          label.includes("class") ||
          label.includes("medium")
        )
          typeId = this.getTypeIdByName('dropdown');
      }

      defaultFieldTypes[obj.id] = typeId;
      return obj;
    };

    // Auto-set default options for known fields
    const seedDefaultOptions = (obj, typeId) => {
      const label = obj.label.toLowerCase();
      const opts = {};
      if (label.includes("gender") || label.includes("sex")) {
        opts[obj.id] = ["Boy", "Girl"];
      } else if (label.includes("status")) {
        opts[obj.id] = ["Active", "Inactive"];
      }
      return opts;
    };

    const allFields =
      getEnquiryFormFields && getEnquiryFormFields.getEnquiryFormFields
        ? getEnquiryFormFields.getEnquiryFormFields
        : [];

    let foundCourse = false;

    allFields.forEach((item) => {
      if (
        !item ||
        !item.field_name ||
        item.id === null ||
        item.id === undefined
      )
        return;
      const originalLabel = item.field_name.toLowerCase();
      const obj = {
        value: item.id,
        label: item.field_name,
        id: item.id.toString(),
      };

      // Ensure only ONE "Course Name" field exists, rename the first, hide the rest
      if (
        originalLabel.includes("course") ||
        originalLabel.includes("courses")
      ) {
        if (!foundCourse) {
          foundCourse = true;
          obj.label = "Enquiry Class";
        } else {
          return;
        }
      }

      // Rebrand Mobile to Primary Contact Number in selectable fields
      if (originalLabel === "mobile" || originalLabel === "student mobile" || originalLabel === "mobile number") {
        obj.label = "Primary Contact Number";
      }

      const label = obj.label.toLowerCase().trim();

      if (label.includes("email")) return; // Email removed from enquiry forms

      if (this.isAcademicDetail(label)) return; // Completely skip these 6 fields

      const isMandatory =
        item.id == 1 ||
        item.id == 2 ||
        this.isBasicLabel(label);
      if (isMandatory) {
        const processed = processField(obj);

        defaultFields.push(processed);
        // Seed options for radio/dropdown default fields
        const auto = seedDefaultOptions(
          processed,
          defaultFieldTypes[processed.id],
        );
        if (auto[processed.id]) {
          // merged later into selectedFieldOptions
          defaultFieldTypes[`__opts_${processed.id}`] = auto[processed.id];
        }
      } else {
        selectableFields.push(processField(obj));
      }
    });

    // ─── ENSURE ALL 12 MANDATORY FIELDS ARE PRESENT IN PREVIEW ───
    const requiredBasic = ["Name", "Primary Contact Number", "Date of Birth", "Gender", "Enquiry Class", "Stream"];

    const currentLabels = defaultFields.map(f => (f.label || "").toLowerCase().trim());

    requiredBasic.forEach((lbl, idx) => {
      const l = lbl.toLowerCase();
      // Check if any variant exists
      const exists = currentLabels.some(cl => {
        const c = cl.toLowerCase();
        if (l === "name" && (c === "name" || c === "student name")) return true;
        if (l === "primary contact number" && (c === "primary contact number" || c === "mobile" || c === "student mobile" || c === "mobile number")) return true;
        if (l === "date of birth" && (c === "dob" || c === "date of birth")) return true;
        if (l === "email" && c.includes("email")) return true;
        if (l === "gender" && (c === "gender" || c === "sex")) return true;
        if (l === "enquiry class" && (c === "enquiry class" || c === "course" || c === "course name")) return true;
        if (l === "stream" && c === "stream") return true;
        return c === l;
      });
      if (!exists) {
        const fakeId = `fixed-b-${idx}`;
        const obj = processField({ id: fakeId, label: lbl, value: fakeId });

        defaultFields.push(obj);
      }
    });

    // ─── SORT DEFAULT FIELDS BY STANDARD ORDER ───
    defaultFields.sort((a, b) => {
      const getOrder = (lbl) => {
        const l = (lbl || "").toLowerCase().trim();
        if (l === "name" || l === "student name") return 0;
        if (l === "primary contact number" || l === "mobile" || l === "student mobile" || l === "mobile number") return 1;
        if (l === "email" || l.includes("email")) return 2;
        if (l === "date of birth" || l === "dob") return 3;
        if (l === "gender" || l === "sex") return 4;
        if (l === "enquiry class" || l === "course" || l === "course name") return 5;
        if (l === "stream") return 6;
        return 99;
      };
      return getOrder(a.label) - getOrder(b.label);
    });

    // Tag each basic field with its stable master key so the label can be edited
    // without losing the field's identity / column mapping.
    defaultFields.forEach((f) => {
      f.key = this.masterKeyForLabel(f.label);
    });



    // ───────────────────────────────────────────────────────────

    const isEditMode = stateData?.existingAdmissionFormFields?.length > 0;
    let formSelectedValue = [];
    let branch_id = "";
    let form_name = "";
    let existing_form_field_id = 0;
    // Extract seeded default options out of the type map
    const seededOptions = {};
    Object.keys(defaultFieldTypes).forEach((k) => {
      if (k.startsWith("__opts_")) {
        const realId = k.replace("__opts_", "");
        seededOptions[realId] = defaultFieldTypes[k];
        delete defaultFieldTypes[k];
      }
    });
    let selectedFieldTypes = {
      ...defaultFieldTypes,
      ...(this.state.selectedFieldTypes || {})
    };
    let selectedFieldOptions = {
      ...seededOptions,
      ...(this.state.selectedFieldOptions || {})
    };
    let selectedFieldLengths = {
      ...(this.state.selectedFieldLengths || {})
    };
    let selectedFieldRequired = {
      ...(this.state.selectedFieldRequired || {})
    };

    if (isEditMode) {
      const existing = stateData.existingAdmissionFormFields[0];
      const defaultIds = defaultFields.map((f) => f.id.toString());
      const formIdToFetch = existing.existing_form_field_id || existing.id || 0;

      this.setState({ loadingSpinner: true });

      let savedFields = [];
      try {
        const result = await this.props.client.query({
          query: gql`
            query ($form_id: Int!) {
              getEnquiryFormFields(form_id: $form_id) {
                id
                field_name
                field_key
                field_type_id
                options
                value_length
                is_required
                order_no
              }
            }
          `,
          variables: { form_id: parseInt(formIdToFetch) },
          fetchPolicy: "network-only",
        });
        savedFields = result.data.getEnquiryFormFields || [];
      } catch (e) {
        console.error("Error fetching saved fields directly", e);
      }

      savedFields.forEach((field) => {
        if (!field || !field.field_name) return;
        const matchingName = field.field_name.toString().trim().toLowerCase();

        // Identify master/basic fields by their stable field_key (falling back to
        // the label for legacy rows). Match against the default field's key so an
        // edited label is correctly recognized and restored.
        const masterKey =
          (field.field_key && this.isMasterKey(field.field_key))
            ? field.field_key
            : this.masterKeyForLabel(field.field_name);

        if (masterKey || this.isBasicLabel(matchingName)) {
          const standard = defaultFields.find((df) => df.key === masterKey)
            || defaultFields.find((df) => (df.label || "").toLowerCase().trim() === matchingName);

          if (standard) {
            const oldId = standard.id;
            standard.id = field.id.toString();
            // The basic field's id is re-pointed to the saved DB row id. Migrate the
            // seeded type/options/length (keyed by the original id) to the new id so
            // they are not orphaned — otherwise the field_type_id falls back to text.
            if (oldId !== standard.id) {
              if (selectedFieldTypes[oldId] != null && selectedFieldTypes[standard.id] == null) {
                selectedFieldTypes[standard.id] = selectedFieldTypes[oldId];
              }
              if (selectedFieldOptions[oldId] != null && selectedFieldOptions[standard.id] == null) {
                selectedFieldOptions[standard.id] = selectedFieldOptions[oldId];
              }
            }
            // Restore the saved (possibly edited) label.
            if (field.field_name) standard.label = field.field_name;
            // Restore saved order so basic fields display in order_no order.
            if (field.order_no != null) standard.order_no = field.order_no;
            // Restore saved max length.
            if (field.value_length != null) selectedFieldLengths[standard.id] = field.value_length;
          }
          return;
        }

        const found = allFields.find(
          (f) => f.field_name && f.field_name.toString().trim().toLowerCase() === matchingName
        );

        if (found && found.id !== null && found.id !== undefined) {
          const idStr = found.id.toString();
          if (!defaultIds.includes(idStr)) {
            formSelectedValue.push(
              processField({
                label: found.field_name,
                value: found.id,
                id: idStr,
              }),
            );
          }
          if (field.field_type_id) {
            // Only use DB value if not already changed locally
            if (!this.state.selectedFieldTypes || !this.state.selectedFieldTypes[idStr]) {
              selectedFieldTypes[idStr] = parseInt(field.field_type_id);
            }
          }
          if (field.options) {
            // Only use DB options if not already changed locally
            if (!this.state.selectedFieldOptions || !this.state.selectedFieldOptions[idStr]) {
              let optionsRaw = field.options;
              if (typeof optionsRaw === 'string') {
                try {
                  optionsRaw = JSON.parse(optionsRaw);
                } catch (e) {
                  optionsRaw = optionsRaw.split(",");
                }
              }
              if (Array.isArray(optionsRaw)) {
                selectedFieldOptions[idStr] = optionsRaw.filter(
                  (o) => typeof o === 'string' && o.trim() !== ""
                );
              }
            }
          }
          if (field.value_length != null && (!this.state.selectedFieldLengths || !this.state.selectedFieldLengths[idStr])) {
            selectedFieldLengths[idStr] = field.value_length;
          }
          if (!this.state.selectedFieldRequired || this.state.selectedFieldRequired[idStr] === undefined) {
            selectedFieldRequired[idStr] = !!field.is_required;
          }
        } else {
          // It's a custom field!
          const customId = "custom_" + field.id;
          formSelectedValue.push({
            label: field.field_name,
            value: customId,
            id: customId
          });
          selectableFields.push({
            label: field.field_name,
            value: customId,
            id: customId
          });
          if (field.field_type_id) {
            if (!this.state.selectedFieldTypes || !this.state.selectedFieldTypes[customId]) {
              selectedFieldTypes[customId] = parseInt(field.field_type_id);
            }
          }
          if (field.options) {
            if (!this.state.selectedFieldOptions || !this.state.selectedFieldOptions[customId]) {
              let optionsRaw = field.options;
              if (typeof optionsRaw === 'string') {
                try {
                  optionsRaw = JSON.parse(optionsRaw);
                } catch (e) {
                  optionsRaw = optionsRaw.split(",");
                }
              }
              if (Array.isArray(optionsRaw)) {
                selectedFieldOptions[customId] = optionsRaw.filter(
                  (o) => typeof o === 'string' && o.trim() !== ""
                );
              }
            }
          }
          if (field.value_length != null && (!this.state.selectedFieldLengths || !this.state.selectedFieldLengths[customId])) {
            selectedFieldLengths[customId] = field.value_length;
          }
          if (!this.state.selectedFieldRequired || this.state.selectedFieldRequired[customId] === undefined) {
            selectedFieldRequired[customId] = !!field.is_required;
          }
        }
      });

      // Restore basic fields in their saved order_no order. Fields without a
      // saved order_no fall back to the standard order so nothing is lost.
      const standardOrder = (lbl) => {
        const l = (lbl || "").toLowerCase().trim();
        if (l === "name" || l === "student name") return 0;
        if (l === "primary contact number" || l === "mobile" || l === "student mobile" || l === "mobile number") return 1;
        if (l === "email" || l.includes("email")) return 2;
        if (l === "date of birth" || l === "dob") return 3;
        if (l === "gender" || l === "sex") return 4;
        if (l === "enquiry class" || l === "course" || l === "course name") return 5;
        if (l === "stream") return 6;
        return 99;
      };
      defaultFields.sort((a, b) => {
        const ao = a.order_no != null ? a.order_no : 1000 + standardOrder(a.label);
        const bo = b.order_no != null ? b.order_no : 1000 + standardOrder(b.label);
        return ao - bo;
      });

      branch_id = stateData.branch_id || "";
      form_name = existing.form_name || "";
      existing_form_field_id = parseInt(formIdToFetch);
    } else {
      branch_id = stateData.branch_id || "";
      if (!branch_id) {
        const authIds = getAuthorizedBranchIds();
        const authorizedBranches = this.props.globals?.globalBranches?.filter(b =>
          authIds.includes(String(b.id))
        );

        if (authorizedBranches && authorizedBranches.length > 0) {
          branch_id = String(authorizedBranches[0].id);
        } else if (this.props.globals?.globalBranches?.length > 0) {
          branch_id = String(this.props.globals.globalBranches[0].id);
        }
      }
    }

    this.setState({
      branch_id,
      branchError: "",
      form_name,
      formNameError: "",
      formSelectedValue,
      defaultSelectedValue: defaultFields,
      selectedFieldTypes,
      selectedFieldOptions,
      selectedFieldLengths,
      selectedFieldRequired,
      optionInputValues: {},
      selectableFields,
      loadingSpinner: false,
      submitError: "",
      submitSuccess: false,
      dataClear: 1,
      existing_form_field_id,
      isEditMode,
      isDisabled: isEditMode,
      // ── Reset custom field state on re-init ──
      customFieldSearch: "",
      customCreateName: "",
      customCreateType: 1, // Will be updated by getTypeIdByName later
      customCreateError: "",
      customFieldSearchError: "",
      isCreatingField: false,
      // ── Reset create field modal on re-init ──
      isCreateFieldModalOpen: false,
      createFieldInput: "",
      createFieldError: "",
    });
  };

  // ── Field Type ───────────────────────────────────────────────
  handleTypeChange = (fieldId, typeId) => {
    this.setState((prevState) => ({
      selectedFieldTypes: {
        ...prevState.selectedFieldTypes,
        [fieldId]: parseInt(typeId),
      },
    }));
  };

  // ── Field Required/Optional (is_required) ────────────────────
  handleRequiredChange = (fieldId, value) => {
    this.setState((prevState) => ({
      selectedFieldRequired: {
        ...prevState.selectedFieldRequired,
        [fieldId]: value === "1" || value === 1 || value === true,
      },
    }));
  };

  // ── Field Max Length (value_length) ──────────────────────────
  handleLengthChange = (fieldId, value) => {
    // Digits only, capped at 3 digits (max 999), minimum 1.
    const cleaned = value.replace(/\D/g, "").slice(0, 3);
    let next = "";
    if (cleaned !== "") {
      next = parseInt(cleaned, 10);
      if (next < 1) next = 1; // min length is 1
    }
    this.setState((prevState) => ({
      selectedFieldLengths: {
        ...prevState.selectedFieldLengths,
        [fieldId]: next,
      },
    }));
  };

  // Required fields are derived from the known default fields.
  isRequiredLabel = (label) => {
    const l = (label || "").toLowerCase().trim();
    return (
      l === "name" ||
      l === "student name" ||
      l === "primary contact number" ||
      l === "mobile" ||
      l === "mobile number" ||
      l === "student mobile" ||
      l === "enquiry class" ||
      l === "course name"
    );
  };

  // Stable master key for a (possibly edited) basic field label. Returns null for
  // custom fields. Used so renaming a static field never loses its column mapping.
  masterKeyForLabel = (label) => {
    const l = (label || "").toLowerCase().trim();
    if (l === "name" || l === "student name" || l === "full name") return "student_name";
    if (["primary contact number", "mobile", "student mobile", "mobile number", "contact number", "phone number"].includes(l)) return "student_mobile";
    if (l.includes("email")) return "student_email";
    if (l === "date of birth" || l === "dob") return "dob";
    if (l === "gender" || l === "sex") return "gender";
    if (l === "enquiry class" || l === "course" || l === "course name") return "enquiry_course_id";
    if (l === "stream") return "stream_id";
    return null;
  };

  isMasterKey = (k) =>
    ["student_name", "student_mobile", "student_email", "dob", "gender", "enquiry_course_id", "stream_id"].includes(k);

  // Which master fields are required.
  isRequiredKey = (k) =>
    ["student_name", "student_mobile", "enquiry_course_id"].includes(k);

  // Default max length shown/saved for master fields.
  defaultLengthForKey = (k) => {
    if (k === "student_name") return 100;
    if (k === "student_mobile") return 10;
    return "";
  };

  // Max length only applies to free-text inputs (text / textarea / number).
  // Date, dropdown, radio and checkbox fields don't show a length input.
  showLengthForField = (typeId, key) => {
    if (["dob", "gender", "enquiry_course_id", "stream_id"].includes(key)) return false;
    const t = parseInt(typeId);
    const noLen = ["dropdown", "radio", "date", "checkbox"].map((n) => parseInt(this.getTypeIdByName(n)));
    return !noLen.includes(t);
  };

  // Edit the label of a static/basic field (its stable key is preserved).
  handleBasicLabelChange = (fieldId, value) => {
    this.setState((prev) => ({
      defaultSelectedValue: prev.defaultSelectedValue.map((f) =>
        f.id === fieldId ? { ...f, label: value } : f,
      ),
    }));
  };

  // Edit the label of a custom/additional field.
  handleAdditionalLabelChange = (fieldId, value) => {
    this.setState((prev) => ({
      formSelectedValue: prev.formSelectedValue.map((f) =>
        f.id === fieldId ? { ...f, label: value } : f,
      ),
    }));
  };

  // ── Options Builder ──────────────────────────────────────────
  handleOptionInputChange = (fieldId, value) => {
    this.setState((prev) => ({
      optionInputValues: { ...prev.optionInputValues, [fieldId]: value },
    }));
  };

  handleAddOption = (fieldId, e = null) => {
    if (e && e.key !== "Enter") return;
    if (e) e.preventDefault();
    const { optionInputValues, selectedFieldOptions } = this.state;
    const val = (optionInputValues[fieldId] || "").trim();
    if (val) {
      const currentOptions = selectedFieldOptions[fieldId] || [];
      if (!currentOptions.includes(val)) {
        this.setState((prev) => ({
          selectedFieldOptions: {
            ...prev.selectedFieldOptions,
            [fieldId]: [...currentOptions, val],
          },
          optionInputValues: { ...prev.optionInputValues, [fieldId]: "" },
        }));
      } else {
        this.setState((prev) => ({
          optionInputValues: { ...prev.optionInputValues, [fieldId]: "" },
        }));
      }
    }
  };

  handleRemoveOption = (fieldId, idx) => {
    this.setState((prev) => {
      const currentOptions = [...(prev.selectedFieldOptions[fieldId] || [])];
      currentOptions.splice(idx, 1);
      return {
        selectedFieldOptions: {
          ...prev.selectedFieldOptions,
          [fieldId]: currentOptions,
        },
      };
    });
  };

  // ── Form Fields ──────────────────────────────────────────────
  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "form_name") {
      this.setState({ form_name: value, formNameError: "", submitError: "" });
    } else if (name === "branch_id") {
      this.setState({ branch_id: value, branchError: "", submitError: "" });
    } else {
      this.setState({ [name]: value, [`${name}Error`]: "", submitError: "" });
    }
  };

  getSectionPrefix = (fieldName) => {
    if (!fieldName) return FIELD_SECTIONS.PERSONAL;
    const lower = fieldName.toLowerCase();
    if (FIELD_MAPPING[lower]) return FIELD_MAPPING[lower];
    if (
      lower.includes("father") ||
      lower.includes("mother") ||
      lower.includes("guardian")
    )
      return FIELD_SECTIONS.FAMILY;
    if (
      lower.includes("address") ||
      lower.includes("city") ||
      lower.includes("state") ||
      lower.includes("pincode")
    )
      return FIELD_SECTIONS.COMMUNICATION;
    return FIELD_SECTIONS.PERSONAL;
  };

  toggleField = (field) => {
    const { formSelectedValue } = this.state;
    const index = formSelectedValue.findIndex((f) => f.id === field.id);
    if (index > -1) {
      const updated = [...formSelectedValue];
      updated.splice(index, 1);
      this.setState({ formSelectedValue: updated, submitError: "" });
    } else {
      this.setState({
        formSelectedValue: [...formSelectedValue, field],
        submitError: "",
      });
    }
  };

  // ── Custom Field — now uses independent customCreateName state ──
  handleCreateOrAddField = async () => {
    const {
      customCreateName,
      customCreateType,
      selectableFields,
      defaultSelectedValue,
      formSelectedValue,
    } = this.state;

    const trimmed = customCreateName.trim();

    // Validate
    if (!trimmed) {
      this.setState({ customCreateError: "Please enter a field name." });
      return;
    }
    if (trimmed.length < 2) {
      this.setState({
        customCreateError: "Field name must be at least 2 characters.",
      });
      return;
    }
    if (!/^[a-zA-Z0-9 _\-]+$/.test(trimmed)) {
      this.setState({
        customCreateError:
          "Only letters, numbers, spaces, underscores and hyphens are allowed.",
      });
      return;
    }

    // Check if field already exists in known pool
    const allKnown = [...defaultSelectedValue, ...selectableFields];
    const match = allKnown.find(
      (f) => f.label.toLowerCase() === trimmed.toLowerCase(),
    );

    if (match) {
      // Already in DB pool — just select it
      const alreadySelected = formSelectedValue.some((f) => f.id === match.id);
      if (!alreadySelected) {
        this.setState((prev) => ({
          formSelectedValue: [...prev.formSelectedValue, match],
          selectedFieldTypes: {
            ...prev.selectedFieldTypes,
            [match.id]: parseInt(customCreateType),
          },
          customCreateName: "",
          customCreateError: "",
        }));
      } else {
        this.setState({
          customCreateError: `"${trimmed}" is already added to the form.`,
        });
      }
      return;
    }

    // Not found → Just add it to selectableFields and formSelectedValue with temp ID
    this.setState({ isCreatingField: true, customCreateError: "" });
    try {
      const tempId = "custom_" + Date.now();
      const fieldObj = {
        id: tempId,
        value: tempId,
        label: trimmed,
      };

      this.setState((prev) => ({
        selectableFields: [...prev.selectableFields, fieldObj],
        formSelectedValue: [...prev.formSelectedValue, fieldObj],
        selectedFieldTypes: {
          ...prev.selectedFieldTypes,
          [fieldObj.id]: parseInt(customCreateType),
        },
        customCreateName: "",
        isCreatingField: false,
      }));
    } catch (err) {
      this.setState({
        customCreateError: "Failed to create field. Please try again.",
        isCreatingField: false,
      });
    }
  };

  // ── Create Field Modal Handler ───────────────────────────────
  handleCreateFieldFromModal = async () => {
    const {
      createFieldInput,
      selectableFields,
      defaultSelectedValue,
      formSelectedValue,
    } = this.state;

    const trimmed = createFieldInput.trim();
    if (!trimmed) {
      this.setState({ createFieldError: "Field name cannot be empty." });
      return;
    }

    // Check if field already exists in known pool
    const allKnown = [...defaultSelectedValue, ...selectableFields];
    const match = allKnown.find(
      (f) => f.label.toLowerCase() === trimmed.toLowerCase(),
    );

    if (match) {
      const alreadySelected = formSelectedValue.some((f) => f.id === match.id);
      if (!alreadySelected) {
        this.setState((prev) => ({
          formSelectedValue: [...prev.formSelectedValue, match],
          selectedFieldTypes: {
            ...prev.selectedFieldTypes,
            [match.id]: this.getTypeIdByName('text'),
          },
          isCreateFieldModalOpen: false,
          createFieldInput: "",
          createFieldError: "",
        }));
      } else {
        this.setState({
          createFieldError: `"${trimmed}" is already added to the form.`,
        });
      }
      return;
    }

    // Not found — Just add it natively
    this.setState({ isCreatingField: true });
    try {
      const tempId = "custom_" + Date.now();
      const fieldObj = {
        id: tempId,
        value: tempId,
        label: toTitleCase(trimmed),
      };

      this.setState((prev) => ({
        selectableFields: [...prev.selectableFields, fieldObj],
        formSelectedValue: [...prev.formSelectedValue, fieldObj],
        selectedFieldTypes: {
          ...prev.selectedFieldTypes,
          [fieldObj.id]: this.getTypeIdByName('text'),
        },
        isCreateFieldModalOpen: false,
        createFieldInput: "",
        createFieldError: "",
        isCreatingField: false,
      }));
    } catch (err) {
      this.setState({
        createFieldError: "Failed to create field. Please try again.",
        isCreatingField: false,
      });
    }
  };

  // ── Drag & Drop ──────────────────────────────────────────────
  // One handler for both drag types: section reordering (the two preview
  // sections) and field reordering (within Additional Details).
  onDragEnd = (result) => {
    if (!result.destination) return;
    if (result.type === "section") {
      const sectionOrder = reorder(
        this.state.sectionOrder,
        result.source.index,
        result.destination.index,
      );
      this.setState({ sectionOrder });
      return;
    }
    if (result.type === "basic-field") {
      const defaultSelectedValue = reorder(
        this.state.defaultSelectedValue,
        result.source.index,
        result.destination.index,
      );
      this.setState({ defaultSelectedValue });
      return;
    }
    const reordered = reorder(
      this.state.formSelectedValue,
      result.source.index,
      result.destination.index,
    );
    this.setState({ formSelectedValue: reordered });
  };

  handleSubmit = async () => {
    const {
      branch_id,
      form_name,
      formSelectedValue,
      defaultSelectedValue,
      sectionOrder,
      selectedFieldTypes,
      selectedFieldOptions,
      selectedFieldLengths,
      selectedFieldRequired,
      existing_form_field_id,
      isEditMode,
    } = this.state;

    // ── Comprehensive validation ──────────────────────────────────────
    let errors = {};
    // Respect the on-screen section order when saving field order.
    const orderedGroups = sectionOrder.map((sec) =>
      sec === "basic" ? defaultSelectedValue : formSelectedValue,
    );
    const allFields = [...orderedGroups[0], ...orderedGroups[1]];

    // Branch
    if (!branch_id && !isEditMode) {
      errors.branchError = "Please select a branch.";
    }

    // Form name
    const nameVal = form_name.trim();
    if (!nameVal) {
      errors.formNameError = "Form name is required.";
    } else if (nameVal.length < 3) {
      errors.formNameError = "Form name must be at least 3 characters.";
    } else if (!/^[a-zA-Z0-9 _\-]+$/.test(nameVal)) {
      errors.formNameError =
        "Form name may only contain letters, numbers, spaces, underscores or hyphens.";
    }

    // Options required for choice-type fields
    const choiceTypes = [
      this.getTypeIdByName('dropdown'),
      this.getTypeIdByName('radio'),
      this.getTypeIdByName('checkbox'),
    ];
    for (const f of allFields) {
      const lblLower = (f.label || "").toLowerCase();
      // Master/basic fields manage their own options (courses, gender, …) — skip.
      const fk = f.key || this.masterKeyForLabel(f.label);
      if (fk || lblLower === "course name" || lblLower === "enquiry class") {
        continue;
      }
      const typeId = selectedFieldTypes[f.id] || this.getTypeIdByName('text');
      if (choiceTypes.includes(parseInt(typeId))) {
        const opts = selectedFieldOptions[f.id] || [];
        if (opts.length < 2) {
          errors.submitError = `Field "${f.label}" is a choice-type (${this.getDynamicFieldTypes().find((t) => t.id === parseInt(typeId))?.label || "choice"}) — please add at least 2 options for it in the canvas.`;
          break;
        }
      }
    }

    // Max length is required for free-text fields (text / textarea / number).
    if (!errors.submitError) {
      for (const f of allFields) {
        const key = f.key || this.masterKeyForLabel(f.label);
        const typeId = selectedFieldTypes[f.id] || this.getTypeIdByName('text');
        if (!this.showLengthForField(typeId, key)) continue;
        const len = selectedFieldLengths[f.id];
        const effective = (len != null && len !== "") ? len : this.defaultLengthForKey(key);
        if (effective === "" || effective == null) {
          errors.submitError = `Please set a max length for "${f.label}".`;
          break;
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ ...errors });
      // Bring the error into view (the alert renders at the top of the fields panel).
      setTimeout(() => {
        const el = document.querySelector(".af-builder-panel-body .alert-danger");
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 50);
      return;
    }
    // ─────────────────────────────────────────────────────────────────

    const allFieldNames = allFields.map((f) => f.label);
    const allFieldTypes = allFields.map(
      (f) => selectedFieldTypes[f.id] || this.getTypeIdByName('text'),
    );
    const allFieldOptions = allFields.map((f) =>
      (selectedFieldOptions[f.id] || []).join(","),
    );
    // Stable field_key per field — master fields carry their key (so renaming the
    // label does not break column mapping); custom fields send "" and the backend
    // derives a key from the name.
    const allFieldKeys = allFields.map(
      (f) => f.key || this.masterKeyForLabel(f.label) || "",
    );
    // value_length per field — fall back to the master-field default (Name 100,
    // Primary Contact Number 10) when the user hasn't set one. Non free-text
    // types (date/dropdown/radio/checkbox) never carry a length.
    const allFieldLengths = allFields.map((f) => {
      const key = f.key || this.masterKeyForLabel(f.label);
      const typeId = selectedFieldTypes[f.id] || this.getTypeIdByName('text');
      if (!this.showLengthForField(typeId, key)) return "";
      const len = selectedFieldLengths[f.id];
      if (len != null && len !== "") return len;
      return this.defaultLengthForKey(key) || "";
    });
    // is_required: master fields use their fixed requiredness; custom fields use
    // the per-field Required/Optional toggle.
    const allFieldRequired = allFields.map((f) => {
      const key = f.key || this.masterKeyForLabel(f.label);
      if (key) return this.isRequiredKey(key) ? 1 : 0;
      return selectedFieldRequired[f.id] ? 1 : 0;
    });

    let params = {};
    if (isEditMode && existing_form_field_id > 0) {
      params = {
        form_name: form_name.trim(),
        form_field_names: allFieldNames.join(","),
        form_field_types: allFieldTypes.join(","),
        form_field_options: allFieldOptions.join("|"),
        form_field_lengths: allFieldLengths.join(","),
        form_field_required: allFieldRequired.join(","),
        form_field_keys: allFieldKeys.join(","),
        updated_by: parseInt(Cookies.get("id")),
        existing_form_field_id,
      };
    } else {
      params = {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(branch_id, 10),
        form_name: form_name.trim(),
        form_field_names: allFieldNames.join(","),
        form_field_types: allFieldTypes.join(","),
        form_field_options: allFieldOptions.join("|"),
        form_field_lengths: allFieldLengths.join(","),
        form_field_required: allFieldRequired.join(","),
        form_field_keys: allFieldKeys.join(","),
        inserted_by: parseInt(Cookies.get("id")),
        existing_form_field_id: 0,
      };
    }

    this.setState({ loadingSpinner: true });
    try {
      await this.props.manageEnquiryFormFields({
        variables: { params },
        update: (store, { data }) => {
          if (data.manageEnquiryFormFields) {
            this.setState({ submitSuccess: true, loadingSpinner: false });
            setTimeout(() => {
              if (typeof this.props.onClose === "function") {
                this.props.onClose({ saved: true });
              } else {
                this.props.history.push("/admission-forms");
              }
            }, 1200);
          }
        },
      });
    } catch (err) {
      const msg =
        err?.graphQLErrors?.[0]?.message ||
        "Something went wrong. Please try again.";
      this.setState({ submitError: msg, loadingSpinner: false });
    }
  };

  handleCancel = () => {
    if (typeof this.props.onClose === "function") {
      this.props.onClose({ saved: false });
    } else {
      this.props.history.push("/admission-forms");
    }
  };

  // ── Renderers ────────────────────────────────────────────────
  renderOptionsBuilder = (fieldId) => {
    const { selectedFieldOptions, optionInputValues } = this.state;
    const options = selectedFieldOptions[fieldId] || [];
    return (
      <div className="af-tag-input-container mt-2">
        {options.map((opt, oIdx) => (
          <span key={oIdx} className="af-tag-pill">
            {opt}
            <i
              className="fas fa-times"
              onClick={() => this.handleRemoveOption(fieldId, oIdx)}
            />
          </span>
        ))}
        <input
          type="text"
          className="af-tag-input"
          placeholder={
            options.length === 0
              ? "Type option and press Enter..."
              : "Add option..."
          }
          value={optionInputValues[fieldId] || ""}
          onChange={(e) =>
            this.handleOptionInputChange(fieldId, e.target.value)
          }
          onKeyDown={(e) => this.handleAddOption(fieldId, e)}
        />
      </div>
    );
  };

  renderPage() {
    const {
      branch_id,
      branchError,
      form_name,
      formNameError,
      isDisabled,
      formSelectedValue,
      selectableFields,
      customFieldSearch,
      defaultSelectedValue,
      sectionOrder,
      selectedFieldTypes,
      selectedFieldOptions,
      selectedFieldLengths,
      selectedFieldRequired,
      submitError,
      loadingSpinner,
      submitSuccess,
      isEditMode,
      // independent create panel state
      customCreateName,
      customCreateType,
      customCreateError,
      isCreatingField,
    } = this.state;
    const { globals } = this.props;

    const trimmedSearch = customFieldSearch.trim().toLowerCase();
    const displayedFields = trimmedSearch
      ? selectableFields.filter((f) =>
        f.label.toLowerCase().includes(trimmedSearch),
      )
      : selectableFields;

    const CHOICE_TYPES = [
      this.getTypeIdByName('dropdown'),
      this.getTypeIdByName('radio'),
      this.getTypeIdByName('checkbox'),
    ];

    const needsOptions = (fieldId) => {
      const field = [...defaultSelectedValue, ...formSelectedValue].find(
        (f) => f.id === fieldId,
      );
      const lblLower = (field?.label || "").toLowerCase();
      if (lblLower === "course name" || lblLower === "enquiry class") {
        return false; // Options are auto-fetched dynamically from DB
      }

      const typeId = parseInt(
        selectedFieldTypes[fieldId] || this.getTypeIdByName('text'),
      );
      return CHOICE_TYPES.includes(typeId);
    };

    // ── Movable preview sections ──────────────────────────────────────
    // "basic" and "additional" are reordered by dragging their headers
    // (see the section-level Droppable in the preview below). The field
    // numbering continues across whichever section is on top.
    const basicFirst = sectionOrder.indexOf("basic") === 0;
    const basicStart = basicFirst ? 0 : formSelectedValue.length;
    const additionalStart = basicFirst ? defaultSelectedValue.length : 0;

    // Fields of the Basic Information section. These are mandatory (can't be
    // removed or have their type changed) but can be dragged to reorder.
    const basicFieldsJsx = (
      <Droppable droppableId="basic-order" type="basic-field">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {defaultSelectedValue.map((field, i) => {
              const fieldKey = field.key || this.masterKeyForLabel(field.label);
              const isOptional = !this.isRequiredKey(fieldKey);
              const lengthVal = selectedFieldLengths[field.id] != null
                ? selectedFieldLengths[field.id]
                : this.defaultLengthForKey(fieldKey);
              return (
                <Draggable key={field.id} draggableId={`basic-${field.id}`} index={i}>
                  {(dp, snap) => (
                    <div
                      ref={dp.innerRef}
                      {...dp.draggableProps}
                      {...dp.dragHandleProps}
                      className={`af-canvas-field ${isOptional ? "" : "af-canvas-field--required"}${snap.isDragging ? " af-canvas-field--dragging" : ""}`}
                      style={{ ...dp.draggableProps.style, cursor: "grab" }}
                    >
                      <div className="af-canvas-field-row">
                        <i
                          className="fas fa-grip-vertical af-canvas-grip"
                          title="Drag to reorder"
                        />
                        <span className="af-drag-num">{basicStart + i + 1}</span>
                        <input
                          type="text"
                          className="af-canvas-name-input"
                          value={field.label}
                          title="Edit field name"
                          onMouseDown={(e) => e.stopPropagation()}
                          onChange={(e) => this.handleBasicLabelChange(field.id, e.target.value)}
                          style={{ flex: 1, minWidth: 0, border: "1px solid #e2e8f0", borderRadius: 6, padding: "4px 8px", fontSize: 14, fontWeight: 600, background: "#fff" }}
                        />
                        <div
                          className="af-canvas-field-controls"
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          <Form.Control
                            as="select"
                            className="af-mini-select"
                            value={selectedFieldTypes[field.id] || this.getTypeIdByName('text')}
                            onChange={() => { }}
                            disabled={true}
                          >
                            {this.getDynamicFieldTypes().map((t) => (
                              <option key={t.id} value={t.id}>{t.label}</option>
                            ))}
                          </Form.Control>
                          {this.showLengthForField(selectedFieldTypes[field.id] || this.getTypeIdByName('text'), fieldKey) && (
                            <Form.Control
                              type="number"
                              min={1}
                              max={999}
                              className="af-mini-select"
                              style={{ width: 90 }}
                              placeholder="Max len"
                              title="Maximum length (max 3 digits)"
                              value={lengthVal != null && lengthVal !== "" ? lengthVal : ""}
                              onChange={(e) => this.handleLengthChange(field.id, e.target.value)}
                            />
                          )}
                          <span className={`af-required-badge ${isOptional ? "af-optional-badge" : ""}`}>
                            {isOptional ? "Optional" : "Required"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );

    // Fields of the Additional Details section (drag-and-drop reorderable).
    const additionalFieldsJsx = (
      <>
        {formSelectedValue.length === 0 && (
          <div className="text-secondary italic mb-3 px-3" style={{ fontSize: '13px' }}>
            Drag and drop fields here to add more...
          </div>
        )}
        <Droppable droppableId="fields-order" type="field">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {formSelectedValue.map((field, i) => {
                const showOpts = needsOptions(field.id);
                const opts = selectedFieldOptions[field.id] || [];
                return (
                  <Draggable key={field.id} draggableId={field.id} index={i}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`af-canvas-field${snapshot.isDragging ? " af-canvas-field--dragging" : ""}`}
                        style={{ ...provided.draggableProps.style, cursor: "grab" }}
                      >
                        <div className="af-canvas-field-row">
                          <i
                            className="fas fa-grip-vertical af-canvas-grip"
                            title="Drag to reorder"
                          />
                          <span className="af-drag-num">{additionalStart + i + 1}</span>
                          <input
                            type="text"
                            className="af-canvas-name-input"
                            value={field.label}
                            title="Edit field name"
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => this.handleAdditionalLabelChange(field.id, e.target.value)}
                            style={{ flex: 1, minWidth: 0, border: "1px solid #e2e8f0", borderRadius: 6, padding: "4px 8px", fontSize: 14, fontWeight: 600, background: "#fff" }}
                          />
                          <div
                            className="af-canvas-field-controls"
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Form.Control
                              as="select"
                              className="af-mini-select"
                              value={selectedFieldTypes[field.id] || this.getTypeIdByName('text')}
                              onChange={(e) => this.handleTypeChange(field.id, e.target.value)}
                            >
                              {this.getDynamicFieldTypes().map((t) => (
                                <option key={t.id} value={t.id}>{t.label}</option>
                              ))}
                            </Form.Control>
                            {this.showLengthForField(selectedFieldTypes[field.id] || this.getTypeIdByName('text')) && (
                              <Form.Control
                                type="number"
                                min={1}
                                max={999}
                                className="af-mini-select"
                                style={{ width: 90 }}
                                placeholder="Max len"
                                title="Maximum length (max 3 digits)"
                                value={
                                  selectedFieldLengths[field.id] != null
                                    ? selectedFieldLengths[field.id]
                                    : ""
                                }
                                onChange={(e) => this.handleLengthChange(field.id, e.target.value)}
                              />
                            )}
                            <Form.Control
                              as="select"
                              className="af-mini-select"
                              style={{ width: 110 }}
                              title="Required or optional"
                              value={selectedFieldRequired[field.id] ? "1" : "0"}
                              onChange={(e) => this.handleRequiredChange(field.id, e.target.value)}
                            >
                              <option value="0">Optional</option>
                              <option value="1">Required</option>
                            </Form.Control>
                            <button
                              type="button"
                              className="af-canvas-remove"
                              onClick={() => this.toggleField(field)}
                              title="Remove field"
                            >
                              <i className="far fa-trash-alt" />
                            </button>
                          </div>
                        </div>
                        {showOpts && (
                          <div
                            className="af-canvas-opts-row"
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <span className="af-canvas-opts-label">
                              <i className="fas fa-tags mr-1" /> Options
                              {opts.length < 2 && (
                                <span className="af-opts-hint"> (min 2 required)</span>
                              )}
                            </span>
                            {this.renderOptionsBuilder(field.id)}
                          </div>
                        )}
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </>
    );

    return (
      <div className="af-shadcn-card">
        {/* ═══ SECTION 1: Form Details ═══════════════════════════════════ */}
        <div className="af-shadcn-card-header border-bottom">
          <div className="af-form-section-heading mb-0 pb-0 border-0">
            <i className="fas fa-file-alt" /> Form Details
          </div>
        </div>
        <div className="af-shadcn-card-content pt-4">
          <Form>
            <Form.Row>
              <Form.Group as={Col} lg={3} md={6} sm={12}>
                <label className="af-field-label">Branch *</label>
                {(() => {
                  let authorizedIds = getAuthorizedBranchIds();
                  const authorizedBranches = globals?.globalBranches
                    ?.filter(b => authorizedIds.includes(String(b.id)));

                  // If branch_id in state is "null" or empty but we have branches, try to pick one
                  const effectiveBranchId = (branch_id === "null" || !branch_id) && authorizedBranches?.length > 0
                    ? String(authorizedBranches[0].id)
                    : branch_id;

                  return (
                    <div className="d-inline-flex align-items-center bg-white border px-3 py-1 rounded shadow-sm w-100" style={{ height: "38px" }}>
                      <i className="fas fa-building text-primary opacity-75 mr-2" />
                      <select
                        name="branch_id"
                        value={effectiveBranchId || ""}
                        onChange={this.handleChange}
                        disabled={isDisabled}
                        className={`border-0 shadow-none font-weight-bold p-0 w-100 ${branchError ? "is-invalid" : ""}`}
                        style={{ cursor: "pointer", color: "#0f172a", background: "transparent", fontSize: "13px", flex: 1, minWidth: 0 }}
                      >
                        <option value="">Select Branch</option>
                        {authorizedBranches?.map((b) => (
                          <option key={b.id} value={b.id}>
                            {b.branch_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                })()}
                {branchError && !(() => {
                  const auth = getAuthorizedBranchIds();
                  return globals?.globalBranches?.filter(b => auth.includes(String(b.id))).length === 1;
                })() && (
                    <div className="invalid-feedback d-block">{branchError}</div>
                  )}
              </Form.Group>

              <Form.Group as={Col} lg={5} md={6} sm={12}>
                <label className="af-field-label">Form Name *</label>
                <Form.Control
                  type="text"
                  name="form_name"
                  value={form_name}
                  onChange={this.handleChange}
                  placeholder="Enquiry Form Name"
                  disabled={isDisabled}
                  className={formNameError ? "is-invalid" : ""}
                  maxLength={50}
                />
                {formNameError ? (
                  <div className="invalid-feedback d-block">
                    {formNameError}
                  </div>
                ) : (
                  <small className="text-muted">
                    3–50 chars. Letters, numbers, spaces, _ and - only.
                  </small>
                )}
              </Form.Group>
            </Form.Row>
          </Form>
        </div>

        {/* ═══ SECTION 2: Builder ════════════════════════════════════════ */}
        <div className="af-shadcn-card-content border-top pt-4">
          <div className="af-form-section-heading">
            <i className="fas fa-tools" /> Form Builder
            {formSelectedValue.length > 0 && (
              <div className="af-badge-pill">
                <div className="af-badge-icon-circle">
                  <i className="fas fa-check" />
                </div>
                <span>
                  {formSelectedValue.length} optional field
                  {formSelectedValue.length !== 1 ? "s" : ""} added
                </span>
              </div>
            )}
          </div>
          <Form.Row className="af-builder-workspace">
            {/* ──────────────────── LEFT PANEL ──────────────────── */}
            <Col
              lg={5}
              className="h-100 mb-4 mb-lg-0 d-flex flex-column"
              style={{ minHeight: 0 }}
            >
              {/* 1. CREATE CUSTOM FIELD — always independent of search */}
              <div className="af-builder-panel mb-3 flex-shrink-0">
                <div className="af-builder-panel-header">
                  <i className="fas fa-plus-circle" /> Create Custom Field
                </div>
                <div className="af-builder-panel-body">
                  <label className="af-field-label">Field Name *</label>
                  <Form.Control
                    type="text"
                    value={customCreateName}
                    onChange={(e) =>
                      this.setState({
                        customCreateName: e.target.value,
                        customCreateError: "",
                      })
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        this.handleCreateOrAddField();
                      }
                    }}
                    placeholder="e.g. Pincode, Qualification, Aadhar No..."
                    className={`mb-2 ${customCreateError ? "is-invalid" : ""}`}
                    maxLength={60}
                  />

                  {customCreateError && (
                    <small className="text-danger d-block mb-2">
                      {customCreateError}
                    </small>
                  )}

                  <button
                    type="button"
                    className="af-save-btn w-100"
                    onClick={this.handleCreateOrAddField}
                    disabled={isCreatingField}
                  >
                    {isCreatingField ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-1" />{" "}
                        Creating...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-plus mr-1" /> Create &amp; Add
                        Field
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* 2. SEARCH + AVAILABLE FIELDS */}
              <div
                className="af-builder-panel d-flex flex-column"
                style={{ flex: "1 1 0", minHeight: 0 }}
              >
                <div className="af-builder-panel-header">
                  <i className="fas fa-search" /> Available Fields
                  <span
                    className="ml-auto"
                    style={{ fontWeight: 400, color: "#94a3b8" }}
                  >
                    {displayedFields.length} shown
                  </span>
                </div>
                <div className="p-3 pb-0 flex-shrink-0">
                  <Form.Control
                    type="text"
                    placeholder="Filter fields..."
                    value={customFieldSearch}
                    onChange={(e) =>
                      this.setState({ customFieldSearch: e.target.value })
                    }
                    className="mb-0"
                  />
                </div>
                <div
                  className="af-field-list overflow-auto"
                  style={{ flex: "1 1 0", minHeight: 0, padding: 0 }}
                >
                  {displayedFields.length === 0 ? (
                    <div className="af-field-list-empty">
                      {customFieldSearch
                        ? `No fields match "${customFieldSearch}"`
                        : "No additional fields available."}
                    </div>
                  ) : (
                    displayedFields.map((field) => {
                      const isChecked = formSelectedValue.some(
                        (f) => f.id === field.id,
                      );
                      return (
                        <label
                          key={field.id}
                          className={`af-field-list-item${isChecked ? " af-field-list-item--checked" : ""}`}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => this.toggleField(field)}
                            className="af-field-checkbox"
                          />
                          <span className="af-field-list-name">
                            {field.label}
                          </span>
                          {isChecked && (
                            <i className="fas fa-check-circle af-field-checked-icon" />
                          )}
                        </label>
                      );
                    })
                  )}
                </div>
              </div>
            </Col>

            {/* ──────────────────── RIGHT: CANVAS ──────────────────── */}
            <Col lg={7} className="h-100" style={{ minHeight: 0 }}>
              <div
                className="af-builder-panel h-100 d-flex flex-column"
                style={{ minHeight: 0 }}
              >
                <div className="af-builder-panel-header">
                  <i className="fas fa-eye" /> Live Preview
                  <span
                    className="ml-auto"
                    style={{ fontWeight: 400, color: "#94a3b8" }}
                  >
                    {defaultSelectedValue.length + formSelectedValue.length}{" "}
                    total field
                    {defaultSelectedValue.length + formSelectedValue.length !==
                      1
                      ? "s"
                      : ""}
                  </span>
                </div>
                <div
                  className="af-builder-panel-body overflow-auto"
                  style={{ flex: "1 1 0", minHeight: 0 }}
                >
                  {submitError && (
                    <div
                      className="alert alert-danger py-2 mb-3"
                      style={{ fontSize: 13, borderRadius: 6 }}
                    >
                      <i className="fas fa-exclamation-circle mr-2" />
                      {submitError}
                    </div>
                  )}

                  {defaultSelectedValue.length === 0 &&
                    formSelectedValue.length === 0 ? (
                    <div className="af-preview-card">
                      <div className="text-center py-4">
                        <i
                          className="fas fa-layer-group af-empty-icon"
                          style={{ fontSize: 28 }}
                        />
                        <p
                          className="text-muted mb-0 mt-2"
                          style={{ fontSize: 13 }}
                        >
                          Select fields from the left to build your form.
                        </p>
                      </div>
                    </div>
                  ) : (
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <div className="af-preview-section">
                        <div className="af-preview-section-title d-flex align-items-center">
                          <span><i className="fas fa-list-ul mr-1" /> Form Fields</span>
                        </div>
                        {basicFieldsJsx}
                        {additionalFieldsJsx}
                      </div>
                    </DragDropContext>
                  )}
                </div>
              </div>
            </Col>
          </Form.Row>
        </div>

        {/* ═══ FOOTER ════════════════════════════════════════════════════ */}
        <div className="af-page-footer">
          {submitSuccess && (
            <div className="af-modal-message success">
              <i className="fas fa-check-circle" /> Form saved! Redirecting...
            </div>
          )}
          <button
            type="button"
            className="af-cancel-btn"
            onClick={this.handleCancel}
            disabled={loadingSpinner}
          >
            Cancel
          </button>
          <button
            type="button"
            className="af-save-btn"
            onClick={this.handleSubmit}
            disabled={loadingSpinner || submitSuccess}
          >
            {loadingSpinner && (
              <span className="spinner-border spinner-border-sm mr-2" />
            )}
            {isEditMode ? "Update Form" : "Create Form"}
          </button>
        </div>
      </div>
    );

  }

  render() {
    const { submitSuccess, isEditMode } = this.state;

    return (
      <Container fluid className="px-4 pb-5">
        {/* Breadcrumb + header only in standalone view (hidden inside the modal,
            which has its own header) */}
        {!this.props.onClose && (
          <>
            <AdmissionBreadcrumb
              className="mt-4 px-0"
              items={[
                { label: 'Enquiries', path: '/admissions-dashboard' },
                { label: 'Forms', path: '/admission-forms' },
                { label: isEditMode ? "Edit Form" : "Create Form" }
              ]}
            />

            <div
              className="af-admin-header mt-4 mb-4 pb-3 border-bottom d-flex align-items-center"
              style={{ gap: "16px" }}
            >
              <div>
                <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
                  <i className="fas fa-file-alt mr-2 text-primary opacity-75" />
                  {isEditMode ? "Edit Enquiry Form" : "Create Enquiry Form"}
                </h4>
              </div>
            </div>
          </>
        )}

        {submitSuccess && (
          <div
            className="d-flex align-items-center p-3 mb-4 rounded border"
            style={{
              backgroundColor: "#f0fdf4",
              borderColor: "#86efac",
              color: "#16a34a",
              fontSize: 14,
            }}
          >
            <i className="fas fa-check-circle mr-2" style={{ fontSize: 18 }} />
            Form saved successfully! Redirecting…
          </div>
        )}

        {this.renderPage()}
      </Container>
    );
  }
}

export default withRouter(
  compose(
    graphql(ADD_ENQUIRY_FORM_DETAILS, { name: "manageEnquiryFormFields" }),
  )(withApollo(CreateAdmissionFormPage)),
);
